(() => {
  const storageKey = 'klever.catalog.view';
  const initialize = (root = document) => {
    root.querySelectorAll('[data-catalog-view]').forEach(results => {
      const controls = results.querySelector('.kb-view-switch');
      if (!controls || controls.dataset.ready) return;
      const buttons = [...controls.querySelectorAll('[data-catalog-view-button]')];
      const apply = view => {
        results.dataset.catalogView = view === 'list' ? 'list' : 'grid';
        buttons.forEach(button => button.setAttribute('aria-pressed',
          String(button.dataset.catalogViewButton === results.dataset.catalogView)));
      };
      let savedView;
      try { savedView = localStorage.getItem(storageKey); } catch (_) { /* Storage can be blocked. */ }
      apply(savedView);
      buttons.forEach(button => button.addEventListener('click', () => {
        apply(button.dataset.catalogViewButton);
        try { localStorage.setItem(storageKey, results.dataset.catalogView); } catch (_) { /* View still works. */ }
      }));
      controls.dataset.ready = 'true';
      controls.hidden = false;
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
